import styles from './NotificationBanner.module.scss';
import { useBasicInfo } from '../_shared/contexts/BasicInfoContext';
import { useUserData } from '@/hooks/useUserData';
import { WaitingRoomBanner, CreatorBanner } from './notificationBannerUseCases';
import { useWaitingRoomStatus } from '@/hooks/useWaitingRoomStatus';
import { useState } from 'react';

export const NotificationBanner: React.FC = () => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const { organizationId } = useBasicInfo();
  const { canManageEvent, isLoading: isUserDataLoading } = useUserData();
  const { waitingRoomStatus, isLoading: isWaitingRoomStatusLoading } = useWaitingRoomStatus({
    organizationId: organizationId ?? '',
  });
  const isLoading = isUserDataLoading || isWaitingRoomStatusLoading;

  const closeBanner = () => {
    setIsBannerVisible(false);
  };

  const eligibleBanners = [
    canManageEvent && <CreatorBanner />,
    waitingRoomStatus?.activated && <WaitingRoomBanner onCloseClick={closeBanner} />,
  ].filter(Boolean);

  if (isLoading || eligibleBanners.length === 0 || !isBannerVisible) return null;

  return (
    <div className={styles.wrapper} role="status">
      <div className={styles.banner} data-name="notification-banner">
        <div className={styles.content}>{eligibleBanners.length > 0 ? eligibleBanners[0] : null}</div>
      </div>
    </div>
  );
};
